import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  root: {
    width: 480,
    padding: theme.spacing(3),
  },
  header: {
    display: "flex",
    flexDirection: "column",
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 500,
  },
  content: {
    fontSize: 14,
    color: theme.palette.grey[700],
    lineHeight: 1.6,
  },
  error: {
    fontSize: 14,
    color: theme.palette.error.main,
  },
}));
